import type {
  BikeTypeV1,
  BikeTypeV2,
  FrameContractDTO,
  InspectionSubType,
  InspectionType,
  LeasingOptionType,
} from "@jobrad-gmbh/bike-leasing-calculator";

const getServiceOptions = (frameContract: FrameContractDTO): LeasingOptionType[] => {
  const orderedInspectionTypes: (InspectionType | boolean)[] = [false, "ivo", "full"];
  const orderedInspectionSubTypes: (InspectionSubType | boolean)[] = [false, "basis", "komfort", "unlimited"];

  const orderedServiceTypeOptions = [...frameContract.bike_services.leasing_options].sort(
    (a, b) =>
      orderedInspectionTypes.indexOf(a.service_type) - orderedInspectionTypes.indexOf(b.service_type) ||
      orderedInspectionSubTypes.indexOf(a.service_subtype) - orderedInspectionSubTypes.indexOf(b.service_subtype),
  );

  const isServiceSelectionMandatory = frameContract.bike_services?.is_mandatory === true;
  if (isServiceSelectionMandatory) {
    return orderedServiceTypeOptions.filter((service) => service.service_type !== false);
  }

  return orderedServiceTypeOptions;
};

const getBikeTypeOptions = (frameContract: FrameContractDTO): BikeTypeV2[] => {
  const orderedBikeTypeMapping = {
    Pedelec: "e_bike",
    Fahrrad: "default_bike",
  } as Record<BikeTypeV1, BikeTypeV2>;

  const orderedAllowedCategories = [...frameContract.allowed_categories].sort(
    (a, b) => Object.keys(orderedBikeTypeMapping).indexOf(a) - Object.keys(orderedBikeTypeMapping).indexOf(b),
  );

  const mappedBikeTypeOptions = orderedAllowedCategories
    .filter((bikeType) => bikeType in orderedBikeTypeMapping)
    .map((bikeType) => orderedBikeTypeMapping[bikeType as BikeTypeV1]);

  if (mappedBikeTypeOptions.length > 0) {
    mappedBikeTypeOptions.push("cargo_bike");
  }

  return mappedBikeTypeOptions;
};

export { getServiceOptions, getBikeTypeOptions };
